import { SplitHeading } from '@/design-system/v2/components/split-heading'
import { cn } from '@/utils/styles/cn'

type ILandingPageHeroHeaderProps = {
    titleText: string
    subtitleText?: string
    className?: string
    titleClassName?: string
    subtitleClassName?: string
    align?: 'center' | 'left'
    variant?: 'light' | 'dark'
    as?: 'h1' | 'h2' | 'h3'
}

export const LandingPageHeroHeader = ({
    titleText,
    subtitleText,
    className,
    titleClassName,
    subtitleClassName,
    align = 'center',
    variant = 'light',
    as = 'h1',
}: ILandingPageHeroHeaderProps) => {
    const isLeft = align === 'left'
    const isDark = variant === 'dark'
    const HeadingTag = as

    return (
        <div className={cn('flex w-full flex-col gap-[18px]', isLeft ? 'items-start' : 'items-center', className)}>
            <HeadingTag
                className={cn(
                    'ds-h1 ds-heading',
                    isLeft ? 'text-left' : 'text-center',
                    isDark ? 'text-white' : 'text-[#0A0A0A]',
                    titleClassName
                )}
            >
                <SplitHeading
                    text={titleText}
                    animate={false}
                    secondLineClassName={isDark ? 'text-white/85' : 'text-[#0A0A0A59]'}
                />
            </HeadingTag>
            {subtitleText && (
                <p
                    className={cn(
                        'ds-subtitle ds-body w-full max-w-[581px] xl:max-w-[700px]',
                        isLeft ? 'text-left' : 'text-center',
                        isDark ? 'text-white/85' : 'text-[#838383]',
                        subtitleClassName
                    )}
                >
                    {subtitleText}
                </p>
            )}
        </div>
    )
}
